import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const formatDate = (d) =>
  d.toLocaleDateString("it-IT", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
const formatTime = (d) =>
  d.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", second: "2-digit" });

export const LiveClock = ({ compact = false, inline = false }) => {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  if (inline) {
    return (
      <span className="inline-flex items-center gap-1.5 text-xs" data-testid="live-clock-inline">
        <Clock className="h-3 w-3 opacity-70" />
        <span className="capitalize">{formatDate(now)}</span>
        <span className="opacity-50">·</span>
        <span className="tabular-nums font-semibold">{formatTime(now)}</span>
      </span>
    );
  }

  if (compact) {
    return (
      <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-800 tabular-nums" data-testid="live-clock-compact">
        <Clock className="h-3.5 w-3.5 text-blue-600" />
        <span>{formatTime(now)}</span>
      </div>
    );
  }

  return (
    <div className="px-4 py-2.5 mx-3 my-2 rounded-md bg-white/5 border border-white/5" data-testid="live-clock">
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.15em] text-blue-300">
        <Clock className="h-3 w-3" />
        <span>Adesso</span>
      </div>
      <div className="text-xs text-slate-200 mt-1 capitalize" data-testid="clock-date">{formatDate(now)}</div>
      <div className="text-base font-display font-semibold tabular-nums text-white" data-testid="clock-time">{formatTime(now)}</div>
    </div>
  );
};
